export default __webpack_public_path__ + "static/media/pro-host.9efe9a65.svg";